<template>
  <!--TAB标题-->
  <van-tabs type="card" @click="change">
	  <van-tab v-for="item in tabList" :title="item">
	  </van-tab>
  </van-tabs>
  <div class="box teal">
    <van-list
        v-model:loading="loading"
        :finished="finished"
        finished-text="没有更多了"
        :immediate-check="false"
        @load="onLoad"
    >
      <van-cell v-for="(item,index) in list" :key="index">
        <router-link class="order" :to="'/orderDetail/' + item.orderId">
          <h2>订单号：{{ item.orderNo }}</h2>
          <p>下单时间：{{ item.createdDate }}</p>
          <p>供应商：{{ item.vendorName }}</p>
          <van-tag round type="success" size="medium" v-if="item.orderStatus === 2">待图书馆审核</van-tag>
          <van-tag round type="success" size="medium" v-if="item.orderStatus === 3">待供应商确认</van-tag>
          <van-tag round type="primary" size="medium" v-if="item.orderStatus === 4">已发货</van-tag>
          <van-tag round type="danger" size="medium" v-if="item.orderStatus === 5">图书馆取消</van-tag>
          <van-tag round type="primary" size="medium" v-if="item.orderStatus === 6">已收货</van-tag>
          <van-tag round type="danger" size="medium" v-if="item.orderStatus === 7">供应商取消</van-tag>
          <div v-for="(order, idx) in item.orderDetlList" class="book" :key="idx">
            <h3>题名：<span v-if="order.book && order.book.title">{{ order.book.title }}</span></h3>
            <p>责任者：<span v-if="order.book && order.book.author">{{ order.book.author }}</span></p>
          </div>
        </router-link>
      </van-cell>
    </van-list>
  </div>
</template>

<script>
import {defineComponent, ref, onMounted} from 'vue';
import {getOrderAll} from '../api/users';
import {isNotEmpty} from '../utils/util';

export default defineComponent({
  name: 'AllOrder',
  setup() {
    const loading = ref(false);
    const finished = ref(false);
    const active = ref(0);
    const list = ref([]);
    const total = ref(0);
    const page = ref(1);
    const tabList = ref(['全部','已取消','待审核','已发货','已收货']);
    const types = ref(['all','cancel','pending','delivering','finished']);
    const onOrderAll = (type) => {
      getOrderAll(page.value, 10, type)
          .then(data => {
            if (data) {
              total.value = data.total;
              if (isNotEmpty(data.items)) {
                list.value = list.value.concat(data.items);
              }
              page.value = page.value + 1;
            }
            loading.value = false; // 加载状态结束
            finished.value = list.value.length >= total.value ? true : false;
          })
          .catch((error) => {
            console.error(error);
          });
    };
    const onLoad = () => {
      if (list.value.length < total.value) {
        onOrderAll(types.value[active.value]);
      } else {
        loading.value = false; // 加载状态结束
        finished.value = list.value.length >= total.value ? true : false;
      }
    };
    const change = (data) => {
		    if(data !== active.value){
            active.value = data;
            page.value = 1;
            total.value = 0;
            list.value = [];
            onOrderAll(types.value[active.value]);
        }
    };
    onMounted(() => {
      onOrderAll(types.value[active.value]);
    });

    return {
      onOrderAll,
      active,
      list,
      onLoad,
      total,
      page,
      loading,
      finished,
      tabList,
      change,
      types
    };
  },
});
</script>

<style scoped lang="less">
@import "../assets/css/box.less";
@import "../assets/css/order.less";
@import "../assets/css/all-order.less";
</style>
